// ============================================================
// 管理员权限守卫组件
// ============================================================

import { useNavigate, Outlet } from 'react-router-dom'
import { Result, Button } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useAuthStore } from '../stores/auth.store'

export default function AdminGuard() {
  const navigate = useNavigate()
  const { isLoggedIn, user } = useAuthStore()

  // 未登录
  if (!isLoggedIn) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0F0F1A',
        }}
      >
        <Result
          icon={<LockOutlined style={{ color: '#6B6B80' }} />}
          title={<span style={{ color: '#FFFFFF' }}>请先登录</span>}
          subTitle={<span style={{ color: '#A0A0B0' }}>访问后台管理系统需要登录</span>}
          extra={
            <Button
              type="primary"
              onClick={() => navigate('/login')}
              style={{
                background: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
                border: 'none',
              }}
            >
              去登录
            </Button>
          }
        />
      </div>
    )
  }

  // 非管理员
  if (user?.role !== 'admin') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0F0F1A',
        }}
      >
        <Result
          icon={<LockOutlined style={{ color: '#EF4444' }} />}
          title={<span style={{ color: '#FFFFFF' }}>无权访问</span>}
          subTitle={<span style={{ color: '#A0A0B0' }}>您没有管理员权限，无法访问后台管理系统</span>}
          extra={
            <Button
              type="primary"
              onClick={() => navigate('/')}
              style={{
                background: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
                border: 'none',
              }}
            >
              返回首页
            </Button>
          }
        />
      </div>
    )
  }

  // 管理员，渲染子路由
  return <Outlet />
}
